import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Submit", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-5 dark:text-primary-black" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-center text-xl font-bold" }, "Submit Answer"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-center" }, "Are you sure you want to proceed with your answers?")
], -1)

import { useRouter } from "vue-router"
  import { IonContent, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, modalController } from "@ionic/vue"
  import Card from "@/components/template/CardTemplate.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'verifySubmit',
  emits: ["submit"],
  setup(__props, { emit }) {

  const name = "Modal"
  
  const router = useRouter()

  const cancel = () => {
    modalController.dismiss(null, "cancel")
  }

  const confirm = () => {
    router.push(router.currentRoute.value.fullPath + "&submit=true")
    modalController.dismiss(name, "confirm")
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  color: "medium",
                  onClick: cancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancel")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButtons), { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  class: "text-primary-violet",
                  onClick: confirm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Confirm")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), { class: "ion-padding" }, {
      default: _withCtx(() => [
        _createVNode(Card, { class: "dark:bg-white" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})